import { SocialShare } from '@effectivastudio/lit-components/components/social_share/element.js';
import { html } from 'lit';

SocialShare.config.icons = {
  facebook: 'facebook-square',
  twitter: 'twitter-square',
  whatsapp: 'whatsapp-square',
  share: 'share-nodes',
};

SocialShare.config.cssClasses = {
  trigger: 'bu-btn btn-naked-dark btn-thin',
  mobileTrigger: 'bu-btn btn-naked-dark btn-thin',
};

// TODO: Remove once fontawesome is completely implemented
SocialShare.prototype.renderIcon = () => {
  return html`
    <bu-icon name=${SocialShare.prototype.icon('share')}></bu-icon>
  `;
};
